type BasicPageProps = {
  title: string;
  children: React.ReactNode;
};
export const BasicPage: React.FC<BasicPageProps> = ({ children }) => {
  return (
    <div className="basic-page">
      {/*<h3>{title}</h3>*/}
      {children}
    </div>
  );
};
